import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Outlier badge (Story 1.5, Design Spec §4.1).
 *
 * Companion pill shown inline after a status badge when the row's
 * `is_outlier` is true. Renders a warning icon + "Outlier" text — never
 * colour-only (NFR8) — and carries the §7 aria-label.
 *
 * The row-level companion treatments (amber row background, breached-tier
 * delta in the alert colour) are the CONSUMING screen's job (Epic 3 / Epic 4)
 * — this story delivers the badge + the delta cell's `breached` affordance
 * only. Pure presentational: no inputs, no events, no data.
 */
@Component({
  selector: 'app-outlier-badge',
  templateUrl: './outlier-badge.component.html',
  styleUrls: ['../pricing-status.css', './outlier-badge.component.css'],
  imports: [CommonModule],
  standalone: true,
})
export class OutlierBadgeComponent {
  readonly ariaLabel =
    'Flagged as outlier — exceeds discount variance threshold on one or more tiers';
}
